import { A } from '@adornis/base/env-info.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { customElement } from 'lit/decorators.js';
import ImageFormular from './../assets/formular.png';

/**
 * @customElement anmeldung-component-formular-base
 *
 * This holds the global styles that are needed for each formular sub-component to render correctly.
 */
@customElement('anmeldung-component-formular-base')
export class AnmeldungPageRegistrationBase extends ChemistryLitElement {
  override styles() {
    return [
      {
        ':host': {
          display: 'block',
          width: '100%',
          height: '100%',

          '.headline': {
            // width: `calc( 100% - 160px )`,
            width: '100%',
            paddingTop: this.spacing.xxl,
            background: `#00000000 url(${A.absoluteUrl(ImageFormular)}) no-repeat center center`,
            backgroundSize: 'cover',
            borderRadius: '35px 0',
            // margin: `${this.spacing.sm} 80px 0 80px`,
            marginTop: this.spacing.sm,

            '.h-content': {
              paddingLeft: this.spacing.xxl,
              paddingRight: this.spacing.xxl,
              background: 'rgba(233,242,170,.8)',
              borderRadius: '35px 0',
              color: '#006359',
            },
          },

          '.form-content-page': {
            'cr-h3': { width: '100%', textAlign: 'center' },

            '> cr-flex': {
              width: '100%',
            },
          },

          '.section-container': {
            justifyContent: 'center',
            flexDirection: 'row',

            '> cr-image': {
              height: '25vh',
              minWidth: '25%',
              width: '30%',
              maxWidth: this.sizes.maxReadableWidth,
              marginTop: '60px',
            },

            '.sc-split': {
              '> *': {
                minWidth: `calc( 50% - ${this.spacing.md} )`,
                width: '100%',
              },
            },

            '.sc-content': {
              width: '100%',
              padding: this.spacing.md,
              gap: this.spacing.md,
              borderRadius: '0px 60px 0px 60px',
              background: '#99c1bd', // @ToDo: Style System Color var?

              '> cr-flex': {
                background: 'white',
                padding: this.spacing.md,
                borderRadius: '0px 40px 0px 40px',
              },

              '> cr-grid': {
                background: 'white',
                padding: this.spacing.md,
                borderRadius: '0px 40px 0px 40px',
              },
            },
          },

          '.check-everything-bar': {
            width: '80%',
            border: `1px solid ${this.colors.accent}`,
            background: this.colors.accent.shade(100),
            borderRadius: this.spacing.lg,
            margin: `${this.spacing.sm} 10%`,
          },
        },
        '@media screen and (max-width: 786px)': {
          ':host': {
            '.headline': {
              padding: this.spacing.xs,
              width: `calc( 100% - calc( ${this.spacing.xs} * 2 ) )`,
              marginLeft: 0,
              marginRight: 0,

              '.h-content': {
                padding: this.spacing.lg,
              },

              '.form-headline': {
                alignItems: 'start !important',
                gap: this.spacing.lg,

                'cr-h2': {
                  width: '100%',
                  textAlign: 'center',
                  fontHeight: this.spacing.md,
                },
              },
            },

            '.form-content-page': {
              gap: this.spacing.xl,
              padding: this.spacing.md,
              paddingTop: this.spacing.lg,
            },

            '.tablet--fullwidth': {
              width: '100% !important',
            },

            '.tablet--flex': {
              flexDirection: 'column !important',
            },

            '.section-container': {
              flexDirection: 'column',
              justifyCenter: 'start',
              alignItems: 'center',
              gap: this.spacing.sm,

              'cr-image': { height: '33vh', minWidth: '20vw', width: '75%', maxWidth: 'none', marginTop: '0px' },
            },
          },
        },
        '@media screen and (max-width: 600px)': {
          ':host .section-container .sc-split': {
            flexDirection: 'column',
            gap: this.spacing.lg,
          },
        },
        '@media screen and (max-width: 480px)': {
          ':host': {
            margin: 'unset',

            '.mobile--fullwidth': {
              width: '100% !important',
            },

            '.mobile--flex': {
              flexDirection: 'column !important',
              alignItems: 'start !important',
            },

            '.form-content-page': {
              padding: this.spacing.xs,
              paddingTop: 0,

              '.section-container': {
                gap: this.spacing.md,
              },
            },
          },
        },
        '.button:not([active])': {
          position: 'relative',
          cursor: 'pointer',
          userSelect: 'none',
          textAlign: 'center',
          transitionDuration: '0.4s',
          '-webkit-transition-duration': '0.4s',
          background: 'white',
        },
        '.button:not([active]):hover': {
          transitionDuration: '0.1s',
          backgroundColor: this.colors.primary,
          color: this.colors.white,
        },
        '.button[active]': {
          position: 'relative',
          color: 'white',
          cursor: 'pointer',
          userSelect: 'none',
          textAlign: 'center',
          transitionDuration: '0.4s',
          '-webkit-transition-duration': '0.4s',
          background: this.colors.primary,
        },
        '.button[active]:hover': {
          transitionDuration: '0.1s',
          backgroundColor: this.colors.primary,
          color: this.colors.white,
        },
        '.button': {
          color: 'black',
          border: 'none',
          position: 'relative',
          cursor: 'pointer',
          userSelect: 'none',
          textAlign: 'center',
          transitionDuration: '0.4s',
          '-webkit-transition-duration': '0.4s',
          background: 'white',
        },
        '.button:hover': {
          transitionDuration: '0.1s',
          backgroundColor: this.colors.primary,
          color: this.colors.white,
        },
        'cr-icon': { color: this.colors.accent },
        'cr-text': { textAlign: 'justify' },
      },
    ];
  }
}
